export default __webpack_public_path__ + "static/media/BMMF-Phone03.9da0227b.webp";